import "./service.css";
import { useRef } from "react";
import { AppWrap, MotionWrap } from "../../wrapper";
import { motion, useScroll, useTransform } from "framer-motion";
import {images} from "../../constants"

/* ===== STATIC DATA ===== */
const services = [
  {
    id: 1,
    title: "Architectural Design & Drafting",
    description:
      "We deliver tailored architectural services designed to meet your specific project requirements. Whether you are an architectural designer, interior designer, or real estate developer, our team is dedicated to understanding your goals and delivering precise, production-ready drafting for architecture, interior design, construction, and permit sets.\n\nBeyond comprehensive 2D documentation, our expert team specializes in advanced 3D modeling, photorealistic rendering, and professional Revit & BIM drafting.",
    icon: images.work,
    image: images.service_img_1,
  },
  {
    id: 2,
    title: "Interior Architecture & Detailing",
    description:
      "Our interior design service seamlessly integrates with your architectural projects, ensuring a cohesive vision from structure to finish. We focus on translating client needs into functional, aesthetically refined spaces that enhance the overall architectural concept.\n\nTo support this process, we deliver photorealistic renderings using industry-standard software compatible with your regional workflow, providing clear visualizations for client presentations and project approvals.",
    icon: images.work,
    image: images.service_img_2,
  },
  {
    id: 3,
    title: "3D Modeling & Rendering",
    description:
      "We deliver comprehensive 3D modeling and rendering services tailored to your exact project requirements. Our team is proficient in all major industry-standard software, ensuring seamless integration with your workflow.\n\nWe specialize in producing stunning, high-quality renderings and animations that accurately bring your architectural visions to life for presentations, marketing, and approvals.",
    icon: images.work,
    image: images.service_img_3,
  },
  {
    id: 4,
    title: "Revit (BIM) Drafting & Modeling",
    description:
      "We leverage Building Information Modeling (BIM) with Revit to deliver precise, intelligent models and coordinated 2D drawings. Our construction documentation provides a reliable base for MEP and other engineering disciplines to integrate their services seamlessly.\n\nThis process ensures flawless coordination across all disciplines and delivers the precise information your team and contractors need to build with confidence.",
    icon: images.work,
    image: images.service_img_4,
  },
];


function Service() {
  const timelineRef = useRef(null);

  /* ===== SCROLL LINE ANIMATION ===== */
  const { scrollYProgress } = useScroll({
    target: timelineRef,
    offset: ["start center", "end end"],
  });

  const lineHeight = useTransform(scrollYProgress, [0, 1], ["0%", "100%"]);

  return (
    <div className="service-section">
      <h1 className="service_title">Our Services</h1>

      <div className="timeline-wrapper" ref={timelineRef}>
        {/* MAIN LINE */}
        <motion.div
          className="timeline-main-line"
          style={{ height: lineHeight }}
        />

        {services.map((item, index) => {
          const isEven = index % 2 === 0;

          return (
            <motion.div
  key={item.id}
  className={`timeline-row ${!isEven ? "reverse" : ""}`}
  initial={{ opacity: 0, y: 80 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6 }}
  viewport={{ once: true }}
>
  {/* LEFT */}
  <div className={`timeline-card left-card ${isEven ? "text-card" : "image-card"}`}>
    {isEven ? (
      <>
        <h3>{item.title}</h3>
        <div className="service-text">
          {item.description.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      </>
    ) : (
      <img src={item.image} alt={item.title} />
    )}
  </div>

  {/* CENTER */}
  <div className="timeline-center">
    <motion.div
      className="timeline-icon"
      initial={{ scale: 0 }}
      whileInView={{ scale: 1 }}
      transition={{ duration: 0.4 }}
      viewport={{ once: true }}
    >
      <img src={item.icon} alt="icon" />
    </motion.div>
  </div>

  {/* RIGHT */}
  <div className={`timeline-card right-card ${isEven ? "image-card" : "text-card"}`}>
    {isEven ? (
      <img src={item.image} alt={item.title} />
    ) : (
      <>
        <h3>{item.title}</h3>
        <div className="service-text">
          {item.description.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>
      </>
    )}
  </div>
</motion.div>

          );
        })}
      </div>
    </div>
  );
}

export default AppWrap(
  MotionWrap(Service, "app__service"),
  "service",
  "app__whitebg",
  false,
  false,
  false,
  
);
